import React, { FC } from "react";
import { Fade } from "react-awesome-reveal";
import classNames from "classnames";
import { DEFAULT_FADE_DURATION } from "@app/constants";
import { RichText } from "../../models";
import { BlockHeader } from "../../../common/block-header/BlockHeader";
import { PerformanceGraph } from "./components/performance-graph/PerformanceGraph";
import { DistributionGraph } from "./components/distribution-graph/DistributionGraph";
import { StatisticsTable } from "./components/statistics-table/StatisticsTable";
import { usePerformanceData } from "./usePerformanceData";

type Props = {
  title: RichText;
};

export const PerformanceGraphs: FC<Props> = ({ title }) => {
  const data = usePerformanceData();

  return (
    <div
      className={classNames(
        "mt-20 space-y-20 px-5",
        "lg:mt-25 lg:space-y-15 lg:px-16",
        "xl:mx-auto xl:mt-40 xl:w-full xl:max-w-[1684px] xl:space-y-25 xl:px-24",
      )}
    >
      <Fade
        duration={DEFAULT_FADE_DURATION}
        triggerOnce
        className={classNames(
          "text-large text-primary-content",
          "xl:mx-auto xl:max-w-[980px] xl:text-center",
          "xxl:text-xx-large",
        )}
      >
        <BlockHeader richText={title} />
      </Fade>
      <div
        className={classNames(
          "flex flex-col gap-20",
          "lg:flex-row lg:gap-15",
          "xl:gap-13",
        )}
      >
        <div
          className={classNames(
            "flex-1 rounded-lg bg-dark px-8 py-10",
            "lg:px-15 lg:py-13",
          )}
        >
          <Fade duration={DEFAULT_FADE_DURATION} triggerOnce>
            <PerformanceGraph
              data={data.performance}
              rate={data.statisticsTable[0].alpian}
            />
          </Fade>
        </div>
        <div
          className={classNames(
            "flex-1 rounded-lg bg-dark px-8 py-10",
            "lg:px-15 lg:py-13",
          )}
        >
          <Fade duration={DEFAULT_FADE_DURATION} triggerOnce>
            <DistributionGraph data={data.distribution} />
          </Fade>
        </div>
      </div>
      <Fade duration={DEFAULT_FADE_DURATION} triggerOnce>
        <StatisticsTable
          data={data.statisticsTable}
          dateFrom={data.dateFrom}
          dateTo={data.dateTo}
        />
      </Fade>
    </div>
  );
};
